import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const AircraftFeeRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--aircraft-fee']}>
    <Route index element={<Index />} />
  </SubRouter>
))
